import {} from 'lodash'; // empty import to make this a file module

declare global {
    interface Promise<T> {
        onZone(zone: { run: (fn: () => any) => any }): Promise<T>;
    }
}

Promise.prototype.onZone = function <T>(this: Promise<T>, zone: { run: (fn: () => any) => any }): Promise<T> {
    return new Promise((resolve, reject) => {
        this.then((value) => zone.run(() => resolve(value))).catch((error) => zone.run(() => reject(error)));
    });
};
